var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { getAbsoluteUrl } from "./services";
const buildUrl = (videoUrl) => {
  const url = new URL("/rich-content/oembed", location.href);
  url.searchParams.append("url", getAbsoluteUrl(videoUrl));
  url.searchParams.append("options.maxWidth", "980");
  return url;
};
const fetchOembed = (url, instance) => {
  return fetch(buildUrl(url), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: instance
    }
  }).then((res) => res.json());
};
const providerBlackList = ["wix", "facebook"];
const fetchEmbedData = (instance) => async (url) => {
  try {
    return fetchOembed(url, instance).then((json) => {
      const _a = json, { html } = _a, rest = __objRest(_a, ["html"]);
      const { provider_name } = rest;
      const res = providerBlackList.includes((provider_name || "").toLowerCase()) ? __spreadValues({}, rest) : __spreadProps(__spreadValues({}, rest), { html });
      return res;
    });
  } catch (e) {
    return new Promise((resolve) => {
      setTimeout(() => resolve({}), 1);
    });
  }
};
export {
  fetchEmbedData,
  fetchOembed
};
//# sourceMappingURL=fetchEmbedData.js.map
